const OSNOVA = 'PMIzvestajiProjekata';

export const urls = {
  VRATI: `${OSNOVA}/Vrati`,
  VRATI_JEDAN: `${OSNOVA}/VratiJedan`,
  VRATI_PREDLOG: `${OSNOVA}/VratiPredlog`,
  SACUVAJ: `${OSNOVA}/IU`,
  VIDLJIVO: `${OSNOVA}/U_Vidljivo`,
  OBRISI: `${OSNOVA}/U_Obrisano`,
  FOTOGRAFIJA_UNOS: `${OSNOVA}/Fotografije_I`,
  FOTOGRAFIJA_IZMENA: `${OSNOVA}/Fotografije_U`,
  FOTOGRAFIJA_BRISANJE: `${OSNOVA}/Fotografije_U_Obrisano`,
};
